// extracted by mini-css-extract-plugin
export default {"mobileVideo":"Video_mobileVideo__1EPKl"};